export default {
  analyze: [],
  negative: [],
  positive: [],
  analyze_presential: []
};
